<template>
	<div class="slideshow">
		<flickity ref="flickity" :options="flickityOptions">
			<div class="slide w-100" v-for="(path, index) in images">
				<img :src="path" class="img-fluid" />
			</div>
		</flickity>
	</div>
</template>
<script>

	import Flickity from 'vue-flickity';
	import 'flickity-fade';

	export default {
		components: {
			Flickity
		},
		props: ['images'],
		data() {
			return {
				flickityOptions: {
					autoPlay: 4000,
					fade: true,
					initialIndex: 0,
					prevNextButtons: false,
					pageDots: false,
					wrapAround: false,
				}
			}
		},
		
		methods: {
			next() {
				this.$refs.flickity.next();
			},
			
			previous() {
				this.$refs.flickity.previous();
			}
		}
	}
</script>

<style scoped lang="scss">
	.slideshow {
		height: 250px;
		overflow: hidden;
		position: relative;
	}
	.slide {
		height: 250px;
		position: absolute;
		width: 100%;
	}
</style>